// Plumbing category data definitions
import { EMERGENCY_TIMELINE_OPTIONS } from '../../data/constants';

// ==================== PLUMBING: Service Categories ====================
export const PLUMBING_SERVICE_CATEGORIES = [
  {
    id: "faucets_fixtures",
    name: "Faucets & Fixtures",
    emoji: "🚿",
    services: [
      { value: "faucet_install", label: "Faucet installation", price: { low: 100, high: 250 } },
      { value: "faucet_repair", label: "Faucet repair", price: { low: 75, high: 175 } },
      { value: "faucet_replace", label: "Faucet replacement", price: { low: 125, high: 275 } },
      { value: "showerhead_install", label: "Showerhead installation", price: { low: 75, high: 150 } },
      { value: "shower_valve", label: "Shower valve repair/replacement", price: { low: 200, high: 450 } },
      { value: "bathtub_faucet", label: "Bathtub faucet repair", price: { low: 150, high: 350 } },
      { value: "outdoor_faucet", label: "Outdoor faucet (hose bib)", price: { low: 125, high: 275 } }
    ]
  },
  {
    id: "toilets",
    name: "Toilets",
    emoji: "🚽",
    services: [
      { value: "toilet_install", label: "Toilet installation", price: { low: 175, high: 400 } },
      { value: "toilet_replace", label: "Toilet replacement", price: { low: 200, high: 450 } },
      { value: "toilet_repair", label: "Toilet repair (running, leaking)", price: { low: 100, high: 225 } },
      { value: "toilet_flange", label: "Toilet flange repair", price: { low: 150, high: 350 } },
      { value: "toilet_wax_ring", label: "Wax ring replacement", price: { low: 100, high: 200 } },
      { value: "toilet_fill_valve", label: "Fill valve/flapper replacement", price: { low: 75, high: 150 } },
      { value: "bidet_install", label: "Bidet attachment installation", price: { low: 100, high: 225 } }
    ]
  },
  {
    id: "sinks_vanities",
    name: "Sinks & Vanities",
    emoji: "🪥",
    services: [
      { value: "sink_install", label: "Sink installation", price: { low: 175, high: 400 } },
      { value: "sink_replace", label: "Sink replacement", price: { low: 200, high: 450 } },
      { value: "vanity_install", label: "Vanity installation", price: { low: 250, high: 550 } },
      { value: "vanity_plumbing", label: "Vanity plumbing hookup", price: { low: 150, high: 300 } },
      { value: "undermount_sink", label: "Undermount sink installation", price: { low: 200, high: 450 } },
      { value: "pedestal_sink", label: "Pedestal sink installation", price: { low: 200, high: 400 } },
      { value: "utility_sink", label: "Utility/laundry sink installation", price: { low: 175, high: 375 } }
    ]
  },
  {
    id: "drains_clogs",
    name: "Drains & Clogs",
    emoji: "🔧",
    services: [
      { value: "drain_cleaning", label: "Drain cleaning", price: { low: 100, high: 250 } },
      { value: "clog_removal", label: "Clog removal (snake/auger)", price: { low: 125, high: 300 } },
      { value: "main_line_clearing", label: "Main line clearing", price: { low: 250, high: 550 } },
      { value: "drain_repair", label: "Drain repair", price: { low: 150, high: 350 } },
      { value: "p_trap_replace", label: "P-trap replacement", price: { low: 75, high: 175 } },
      { value: "floor_drain", label: "Floor drain service", price: { low: 125, high: 275 } },
      { value: "camera_inspection", label: "Camera inspection", price: { low: 150, high: 350 } }
    ]
  },
  {
    id: "disposals_appliances",
    name: "Garbage Disposals & Appliance Connections",
    emoji: "🗑️",
    services: [
      { value: "disposal_install", label: "Garbage disposal installation", price: { low: 150, high: 350 } },
      { value: "disposal_replace", label: "Garbage disposal replacement", price: { low: 175, high: 375 } },
      { value: "disposal_repair", label: "Garbage disposal repair", price: { low: 100, high: 225 } },
      { value: "dishwasher_hookup", label: "Dishwasher hookup", price: { low: 125, high: 275 } },
      { value: "washing_machine_hookup", label: "Washing machine hookup", price: { low: 150, high: 300 } },
      { value: "refrigerator_line", label: "Refrigerator water line", price: { low: 125, high: 275 } },
      { value: "ice_maker_line", label: "Ice maker line installation", price: { low: 100, high: 225 } }
    ]
  },
  {
    id: "pipes_leaks",
    name: "Pipes & Leaks",
    emoji: "💧",
    services: [
      { value: "leak_repair", label: "Leak repair", price: { low: 150, high: 400 } },
      { value: "pipe_repair", label: "Pipe repair", price: { low: 175, high: 450 } },
      { value: "pipe_replace", label: "Pipe replacement (section)", price: { low: 250, high: 600 } },
      { value: "water_line_repair", label: "Water line repair", price: { low: 200, high: 500 } },
      { value: "shutoff_valve", label: "Shut-off valve replacement", price: { low: 100, high: 250 } },
      { value: "supply_line", label: "Supply line replacement", price: { low: 100, high: 225 } },
      { value: "pipe_insulation", label: "Pipe insulation", price: { low: 75, high: 200 } },
      { value: "frozen_pipe", label: "Frozen pipe thawing", price: { low: 150, high: 350 } }
    ]
  },
  {
    id: "water_heaters",
    name: "Water Heaters",
    emoji: "🔥",
    services: [
      { value: "water_heater_install", label: "Water heater installation", price: { low: 400, high: 900 } },
      { value: "water_heater_replace", label: "Water heater replacement", price: { low: 450, high: 1000 } },
      { value: "water_heater_repair", label: "Water heater repair", price: { low: 150, high: 400 } },
      { value: "tankless_install", label: "Tankless water heater installation", price: { low: 600, high: 1500 } },
      { value: "water_heater_flush", label: "Water heater flush/maintenance", price: { low: 100, high: 200 } },
      { value: "anode_rod", label: "Anode rod replacement", price: { low: 125, high: 250 } },
      { value: "expansion_tank", label: "Expansion tank installation", price: { low: 150, high: 300 } }
    ]
  },
  {
    id: "outdoor_plumbing",
    name: "Outdoor Plumbing",
    emoji: "🌳",
    services: [
      { value: "sprinkler_repair", label: "Sprinkler system repair", price: { low: 100, high: 275 } },
      { value: "irrigation_install", label: "Irrigation line installation", price: { low: 200, high: 500 } },
      { value: "outdoor_faucet_install", label: "Outdoor faucet installation", price: { low: 150, high: 325 } },
      { value: "hose_bib_repair", label: "Hose bib repair", price: { low: 100, high: 225 } },
      { value: "sewer_line_repair", label: "Sewer line repair", price: { low: 300, high: 800 } },
      { value: "sump_pump", label: "Sump pump installation/repair", price: { low: 250, high: 600 } },
      { value: "backflow_preventer", label: "Backflow preventer installation", price: { low: 200, high: 450 } }
    ]
  },
  {
    id: "troubleshooting",
    name: "Troubleshooting & Diagnostics",
    emoji: "🔍",
    services: [
      { value: "plumbing_inspection", label: "Plumbing inspection", price: { low: 75, high: 175 } },
      { value: "leak_detection", label: "Leak detection", price: { low: 150, high: 350 } },
      { value: "water_pressure_issue", label: "Water pressure diagnosis", price: { low: 100, high: 250 } },
      { value: "noise_diagnosis", label: "Pipe noise diagnosis", price: { low: 100, high: 225 } },
      { value: "water_quality", label: "Water quality assessment", price: { low: 75, high: 175 } },
      { value: "emergency_shutoff", label: "Emergency shut-off service", price: { low: 100, high: 250 } }
    ]
  }
];

// Build price lookup from categories
export const PLUMBING_SERVICE_PRICES = {};
PLUMBING_SERVICE_CATEGORIES.forEach(cat => {
  cat.services.forEach(svc => {
    PLUMBING_SERVICE_PRICES[svc.value] = svc.price;
  });
});

// ==================== PLUMBING QUESTIONS ====================
export const PLUMBING_QUESTIONS = [
  {
    id: "plumbing_services",
    question: "What plumbing services do you need?",
    subtitle: "Browse categories below and select all services that apply",
    type: "collapsible_categories",
    categories: PLUMBING_SERVICE_CATEGORIES
  },
  
  // Follow-up questions for specific services
  {
    id: "fixture_quantity",
    question: "How many fixtures need work?",
    type: "radio",
    showIfAnyService: ["faucet_install", "faucet_repair", "faucet_replace", "showerhead_install", "toilet_install", "toilet_replace", "toilet_repair", "sink_install", "sink_replace"],
    options: [
      { value: "1", label: "1 fixture" },
      { value: "2-3", label: "2-3 fixtures" },
      { value: "4-6", label: "4-6 fixtures" },
      { value: "7+", label: "7+ fixtures" }
    ]
  },
  {
    id: "drain_location",
    question: "Which drains need service?",
    type: "checkbox",
    showIfAnyService: ["drain_cleaning", "clog_removal", "drain_repair"],
    options: [
      { value: "kitchen", label: "Kitchen sink" },
      { value: "bathroom_sink", label: "Bathroom sink" },
      { value: "shower", label: "Shower/tub" },
      { value: "toilet", label: "Toilet" },
      { value: "floor_drain", label: "Floor drain" },
      { value: "main_line", label: "Main line" }
    ]
  },
  {
    id: "water_heater_type",
    question: "What type of water heater?",
    type: "radio",
    showIfAnyService: ["water_heater_install", "water_heater_replace", "water_heater_repair"],
    options: [
      { value: "tank_gas", label: "Tank (Gas)" },
      { value: "tank_electric", label: "Tank (Electric)" },
      { value: "tankless_gas", label: "Tankless (Gas)" },
      { value: "tankless_electric", label: "Tankless (Electric)" },
      { value: "not_sure", label: "Not sure" }
    ]
  },
  {
    id: "leak_severity",
    question: "How severe is the leak?",
    type: "radio",
    showIfAnyService: ["leak_repair", "pipe_repair", "water_line_repair"],
    options: [
      { value: "dripping", label: "Dripping/minor" },
      { value: "steady", label: "Steady flow" },
      { value: "active_leak", label: "Active leak (water damage risk)" },
      { value: "emergency", label: "Emergency (water shut off)" }
    ]
  },
  {
    id: "pipe_material",
    question: "Do you know your pipe material?",
    type: "radio",
    showIfAnyService: ["pipe_repair", "pipe_replace", "water_line_repair"],
    options: [
      { value: "copper", label: "Copper" },
      { value: "pvc", label: "PVC/Plastic" },
      { value: "galvanized", label: "Galvanized steel" },
      { value: "pex", label: "PEX" },
      { value: "not_sure", label: "Not sure" }
    ]
  },
  {
    id: "access_difficulty",
    question: "How accessible is the plumbing area?",
    type: "radio",
    options: [
      { value: "easy", label: "Easy access (under sink, exposed)" },
      { value: "moderate", label: "Moderate (crawl space, attic)" },
      { value: "difficult", label: "Difficult (behind walls, underground)" },
      { value: "not_sure", label: "Not sure" }
    ]
  },
  
  // Common questions
  {
    id: "home_age",
    question: "How old is your home?",
    type: "radio",
    options: [
      { value: "under_20", label: "Under 20 years" },
      { value: "20-40", label: "20-40 years" },
      { value: "40_plus", label: "40+ years" },
      { value: "not_sure", label: "Not sure" }
    ]
  },
  {
    id: "timeline",
    question: "When do you need this done?",
    type: "radio",
    options: EMERGENCY_TIMELINE_OPTIONS
  }
];

// Quantity multipliers for pricing
export const PLUMBING_QUANTITY_MULTIPLIERS = {
  "1": 1,
  "2-3": 2.25,
  "4-6": 4.5,
  "7+": 7
};

// Access difficulty modifiers
export const ACCESS_DIFFICULTY_MODIFIERS = {
  easy: { low: 0, high: 0 },
  moderate: { low: 50, high: 100 },
  difficult: { low: 150, high: 300 },
  not_sure: { low: 25, high: 50 }
};

// Leak severity modifiers
export const LEAK_SEVERITY_MODIFIERS = {
  dripping: { low: 0, high: 0 },
  steady: { low: 25, high: 75 },
  active_leak: { low: 75, high: 150 },
  emergency: { low: 150, high: 300 }
};
